var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('h1',{staticClass:"mb-2 text-gray-800 text-left"},[_vm._v("Houses")]),_c('p',{staticClass:"mb-4 text-left"},[_vm._v("Listado de casas en la plataforma.")])])
}]

export { render, staticRenderFns }